import React from "react";
import { BsX } from "react-icons/bs";

import "./index.css";
const PopupModal = ({ children, showModal, modalName, closeBtn, paddingTop, mb, width }) => {
  return (
    <>
      {showModal && (
        <div className="modal">
          <div className="modal-content" style={{ paddingTop: paddingTop ? paddingTop : "15px", width: width || "fit-content" }}>
            <div className={`d-flex justify-content-between gap-3 ${mb ? mb : "mb-1"}`}>
              <p className="modal-heading">{modalName}</p>
              <BsX onClick={closeBtn} className="close-btn" />
            </div>

            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default PopupModal;
